import {
  INIT_SIGNOUT,
  SET_CURRENCY,
  CUSTOM_PRICING_PLAN,
  CLEAR_CHECKOUT,
  PRICING_PLAN,
  UPDATE_CHECKOUT_PROMO_CODE,
  UPDATE_OFFER_STATUS,
  UPDATE_OFFER_NAME,
  PAYEE_INFO,
  UPDATE_PROMO_AMOUNT,
  SAVE_SUBSCRIPTION_TYPE,
  SAVE_PAYMENT_GATEWAY_TYPE,
  SAVE_INDIAN_CURRENCY_PLAN,
  SHOW_PRICING_TOGGLE,
  SET_PROMO_PERCENTAGE,
  SET_SUBSCRIPTION_PLAN,
} from '../Actions/actionTypes';

const INIT_STATE = {
  currency: 'INR',
  currencySymbol: '₹',
  phoneCode: '+91',
  countryCode: '',
  selectedCourses: [],
  totalAmount: 0,
  amountToPay: 0,
  subscriptionType: '',
  showTazapayPayment: false,
  selectedIndianInrPrice: [],
  selectedIndianUSDPrice: [],
  pricingToggleStatus: false,
  promoPercentValue: '',
  isSubscriptionPlan: false,
  checkoutPromoCode: false,
  offerPricingStatus: false,
  offerPricingName: '',
};

const Pricing = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_SIGNOUT:
      return INIT_STATE;

    case CLEAR_CHECKOUT:
      return {
        ...state,
        selectedCourses: [],
        totalAmount: 0,
      };

    case UPDATE_CHECKOUT_PROMO_CODE:
      return {
        ...state,
        checkoutPromoCode: action.promoCode,
      };

    case UPDATE_OFFER_STATUS:
      return {
        ...state,
        offerPricingStatus: action.status,
      };

    case UPDATE_OFFER_NAME:
      return {
        ...state,
        offerPricingName: action.value,
      };

    case SET_CURRENCY:
      return {
        ...state,
        currency: action.currency,
        currencySymbol: action.currencySymbol,
        countryCode: action.countryCode,
      };

    case CUSTOM_PRICING_PLAN:
      return {
        ...state,
        selectedCourses: action.selectedCourses,
        totalAmount: action.totalAmount,
      };

    case PRICING_PLAN:
      return {
        ...state,
        selectedCourses: action.selectedCourses,
        totalAmount: action.selectedCourses.reduce((acc, cur) => acc + cur.price, 0),
      };

    case UPDATE_PROMO_AMOUNT:
      return {
        ...state,
        amountToPay: action.amountToPay,
      };

    case SAVE_SUBSCRIPTION_TYPE:
      return {
        ...state,
        subscriptionType: action.subscriptionType,
      };

    case SAVE_PAYMENT_GATEWAY_TYPE:
      return {
        ...state,
        showTazapayPayment: action.gatewayType,
      };

    case PAYEE_INFO:
      return {
        ...state,
        ...action.info,
      };

    case SAVE_INDIAN_CURRENCY_PLAN:
      return {
        ...state,
        selectedIndianInrPrice: action.selectedIndianInrPrice,
        selectedIndianUSDPrice: action.selectedIndianUSDPrice,
      };

    case SHOW_PRICING_TOGGLE:
      return {
        ...state,
        pricingToggleStatus: action.pricingToggleStatus,
      };

    case SET_PROMO_PERCENTAGE:
      return {
        ...state,
        promoPercentValue: action.promoPercentValue,
      };

    case SET_SUBSCRIPTION_PLAN:
      return {
        ...state,
        isSubscriptionPlan: action.status,
      };

    default:
      return state;
  }
};

export default Pricing;
